export const INITIAL_HEAT_MAP_RADIUS = 50;
export const INITIAL_HEAT_MAP_OPACITY = 0.2;
export const INITIAL_FILL_COLOR = '#005512';
export const INITIAL_LINE_COLOR = '#000000';
export const lineParameters: any = {
  countryx: { col: 'red', num: 1, offset: 2.5 },
  countyx: { col: 'blue', num: 1, offset: 2.5 },
  subcountyx: { col: 'darkblue', num: 1, offset: 6 },
  wardx: { col: 'yellow', num: 2, offset: 3 },
  catchmentx: { col: 'purple', num: 3, offset: 1 }
};
